import { MenuItem, Select, styled, Tooltip } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { useCommonTranslation } from '../../hooks/useCommonTranslation';

export interface SelectEditCellValue {
  value: string;
  tooltip?: string;
}

const StyledSelectedText = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: 14,
}));

const SelectEditComponent = (props: any) => {
  const t = useCommonTranslation();
  const { id, value, field, colDef } = props;
  const options = colDef.valueOptions;
  const apiRef = useGridApiContext();

  const handleChange = (event: any) => {
    apiRef.current.setEditCellValue({
      id,
      field,
      value: event.target.value,
    });
  };

  return (
    <Select
      value={value}
      onChange={handleChange}
      displayEmpty
      sx={{ width: '100%' }}
      renderValue={(selected) => {
        if (!selected || selected === '') {
          return <StyledSelectedText>{t('common.select')}</StyledSelectedText>;
        }
        const matchingOption = options.find(
          (option: any) => colDef.getOptionValue(option).value === selected,
        );
        let selectedText = '';
        if (matchingOption) {
          selectedText = colDef.getOptionLabel(matchingOption);
        }
        return <StyledSelectedText>{selectedText}</StyledSelectedText>;
      }}>
      {options.map((option: any) => {
        const optionValue = colDef.getOptionValue(
          option,
        ) as SelectEditCellValue;
        const label = colDef.getOptionLabel(option);
        return (
          <MenuItem key={optionValue.value} value={optionValue.value}>
            {optionValue.tooltip && (
              <Tooltip title={optionValue.tooltip} placement="right">
                {label}
              </Tooltip>
            )}
            {!optionValue.tooltip && label}
          </MenuItem>
        );
      })}
    </Select>
  );
};

export const SelectEditCell = (params: any) => (
  <SelectEditComponent {...params} />
);
